import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@material-ui/core";
import {
  deleteAdminRequest,
  getAdminRequests,
} from "services/commonUseDataSetsApi";

export default function AdminRequests() {
  const { getAccessTokenSilently } = useAuth0();
  const history = useHistory();
  const [requests, setRequests] = React.useState([]);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [deletingId, setDeletingId] = React.useState(null);

  const loadRequests = React.useCallback(async () => {
    try {
      const { data } = await getAdminRequests(getAccessTokenSilently);
      setRequests(data.requests);
      setErrorMessage("");
    } catch (error) {
      setErrorMessage(
        error.response?.data?.messages?.authError ||
          error.response?.data?.messages?.databaseError ||
          "The data requests could not be loaded.",
      );
    }
  }, [getAccessTokenSilently]);

  React.useEffect(() => {
    loadRequests();
  }, [loadRequests]);

  async function deleteRequest(request) {
    const confirmed = window.confirm(
      `Delete data request ${request.id} from ${request.requester_name}? This cannot be undone.`,
    );
    if (!confirmed) return;

    try {
      setDeletingId(request.id);
      setErrorMessage("");
      await deleteAdminRequest(request.id, getAccessTokenSilently);
      setRequests((current) =>
        current.filter((item) => item.id !== request.id),
      );
    } catch (error) {
      setErrorMessage(
        error.response?.data?.messages?.authError ||
          error.response?.data?.messages?.databaseError ||
          "The data request could not be deleted.",
      );
    } finally {
      setDeletingId(null);
    }
  }

  return (
    <Paper>
      <Typography variant="h3">Data Requests</Typography>
      {errorMessage && <Typography color="error">{errorMessage}</Typography>}
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Requester</TableCell>
            <TableCell>Institution</TableCell>
            <TableCell>Study</TableCell>
            <TableCell>Submitted</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {requests.map((request) => (
            <TableRow key={request.id}>
              <TableCell>{request.requester_name}</TableCell>
              <TableCell>{request.institution}</TableCell>
              <TableCell>{request.study_slug}</TableCell>
              <TableCell>
                {new Date(request.created_at).toLocaleDateString()}
              </TableCell>
              <TableCell>{request.status}</TableCell>
              <TableCell>
                <Button
                  onClick={() =>
                    history.push(
                      `/portal/common-use-data-sets/admin/${request.id}`,
                    )
                  }
                >
                  Review
                </Button>
                <Button
                  color="secondary"
                  disabled={deletingId === request.id}
                  onClick={() => deleteRequest(request)}
                >
                  {deletingId === request.id ? "Deleting..." : "Delete"}
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}
